import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 保存类型
 */
class SaveType extends UltMeta {
    SAVE_TO_DRAFT = new Meta(1, "保存为草稿");
    SAVE_AND_COMMIT = new Meta(2, "保存并提交");
}

export const SAVE_TYPE = new SaveType();

/**
 * 进销存 入库管理状态
 */
class Status extends UltMeta {
    DRAFT = new Meta(1, "草稿");
    TO_BE_INBOUND = new Meta(2, "待入库");
    INBOUNDED = new Meta(3, "已入库");
    INBOUND_INVALID = new Meta(4, "已作废");
}

export const STATUS = new Status();

/**
 * 数据库只有签署中和确认中的状态 其他用来查询
 * 仓储监控--入库管理状态
 */
class StockStatus extends UltMeta {
    DRAFT = new Meta(1, "草稿");
    TO_BE_SIGN = new Meta(5, "待签署");
    CONFIRMING = new Meta(9, "确认中");
    SIGNING = new Meta(6, "签署中");
    REJECTED = new Meta(7, "已驳回");
    INBOUNDED = new Meta(3, "已入库");
    INVALIDED = new Meta(10, "作废中");
    INBOUND_INVALID = new Meta(4, "已作废");
    // 查询
    // TO_BE_CONFIRM = new Meta(8, "待确认");
    // TO_BE_INBOUND = new Meta(2, "待入库");
}

export const STOCK_STATUS = new StockStatus();

/**
 * 仓储监控--入库管理状态 查询用
 */
class StockStatusAdmin extends UltMeta {
    TO_BE_CONFIRM = new Meta(8, "待确认");
    TO_BE_SIGN = new Meta(5, "待签署");
    SIGNING = new Meta(6, "签署中");
    INBOUNDED = new Meta(3, "已入库");
    INVALIDED = new Meta(10, "作废中");
    INBOUND_INVALID = new Meta(4, "已作废");
}

export const STOCK_STATUS_ADMIN = new StockStatusAdmin();

/**
 * 入库类型
 */
class InboundType extends UltMeta {
    PURCHASE_INBOUND = new Meta(1, "采购入库");
    REFUND_NECK_INBOUND = new Meta(2, "退领入库");
    ALLOT_INBOUND = new Meta(3, "调拨入库");
    INVENTORY_PROFIT_INBOUND = new Meta(4, "盘盈入库");
    SALES_RETURNS_INBOUND = new Meta(5, "销售退货入库");
    PLEDGE_INBOUND = new Meta(16, "质押入库");
    OTHER_INBOUND = new Meta(6, "其他入库");
}

export const INBOUND_TYPE = new InboundType();

/**
 * 签署方式
 */
class SignMode extends UltMeta {
    ONLINE = new Meta(1, "线上");
    OFFLINE = new Meta(2, "线下");
}

export const SIGN_MODE = new SignMode();
